<template>
  <Modal>
    <template v-slot:header>
      {{ $t('EXPIRED_SESION_title') }}
    </template>

    <template v-slot:body>
      <div class="bodyContainer">
        <div class="imagen">
          <img src="../../images/sesion_expirada.png" width="40" />
        </div>
        <div class="texto">{{ $t('EXPIRED_SESION_msg') }}</div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="footerContainer">
        <el-button type="primary" @click="onCloseModal">{{ $t('GENERAL_okBtn') }}</el-button>
      </div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '../Modal/index'

  export default {
    name: 'SesionExpiradaModal',
    components: { Modal },
    props: { onCloseModal: Function }
  }

</script>

<style scoped>

  .bodyContainer {
    display: inline-block;
    width: 100%;
  }

  .bodyContainer .imagen {
    width: 40px; 
    float: left
  }

  .bodyContainer .texto {
    text-align: left;
    padding: 2px 0px;
    width: calc(100% - 60px);
    float: right;
  }

  .footerContainer {
    text-align: right;
  }  
</style>